<div class=" wb-coverage-wrapper">
  <div class="grid-x">
    <div class="cell medium-6">
      <h2 class="main-modal-heading">Set Contribution</h2>
    </div>
    <div class="cell medium-6 contribution-button-container ">
      <mat-dialog-actions class="text-right">
        <button class="button mat-raised-button" [disabled]="disable" (click)="confirm()">Confirm</button>
        <button class="mat-raised-button mat-primary" (click)="close()">Cancel</button>
      </mat-dialog-actions>
    </div>
  </div>
  <hr class="solid mb-0">
  <div>
    <div class="cell medium-6">
      <h3 class="mt-0">Contribution Type </h3>
    </div>
  </div>
  <mat-tab-group class="enhanced-tab" [selectedIndex]="selectedIndex" (selectedTabChange)="selectedTabValue($event)"
    #tabGroup>
    <ng-container>
      <mat-tab *ngFor="let contributionAmountType of contributionAmountTypes; let i = index"
        [label]="contributionAmountType">
        <ng-template mat-tab-label>
          <mat-radio-button class="tp-radio-button" [checked]="i == selectedIndex"> {{contributionAmountType}}
          </mat-radio-button>
        </ng-template>
        <div style="padding: 10px;" *ngIf="selectedTab == 'No Contribution'">
          <h3>No Contribution</h3>
        </div>
        <div *ngIf="selectedTab == 'Percentage'">
          <section class="container">
            <div class="grid-x">
              <div class="cell medium-12">
                <div style="margin-bottom:0px !important;padding: 0px;">
                </div>
              </div>
            </div>
          </section>
          <section class="container">
            <div class="grid-x p-16">
              <div class="cell">
                <div class="grid-x">
                  <div class="cell medium-12">
                    <h3 class="contribution-heading">Single Carrier Package</h3>
                  </div>
                  <div class="cell medium-12 contribution-label-large"> {{carrieName}}</div>
                </div>
                <div class="cell medium-8 contribution-label-large p-0 "> Pay Period Type: </div>
                <div class="cell medium-12 p-0">
                  <mat-radio-group class="type-radio-buttons" [(ngModel)]="payPeriodSelected">
                    <mat-radio-button *ngFor="let payperiod of payPeriodList;let i=index"
                      [value]="payperiod.payPeriodId" class="contribution-label-large"
                      (change)="payPeriodTypeChange($event,index)"> {{payperiod.payPeriodName}}</mat-radio-button>
                  </mat-radio-group>
                </div>
                <div class="grid-x medium-12">
                  <div class="cell ">
                    <h3 class="contribution-label-large">Employer will pay a minimum of 50% of the cost</h3>
                  </div>
                  <div class="medium-12">
                    <fieldset class="grid-x">
                      <div class="medium-12">
                        <span class="fieldset-heading">ER Contribution to EE Premium </span>
                      </div>
                      <div class="grid-x medium-12">
                        <div class="medium-10">
                          <mat-slider #erToEESlider step="1" class="tp-margin contribution-slider" [min]="0" [max]="100"
                            (input)="onChangeEEPercentageSlider($event)" [(ngModel)]="minERContribution">
                          </mat-slider>
                        </div>
                        <div class="medium-2">
                          <div class="text-center contribution-label" style="font-size: larger;padding: 0px;">
                            <input type="number" size="3" (keypress)="numberOnly($event)"
                              class="mat-form-field-outline contribution-percentage"
                              (blur)="setPercentageZeroContribution($event)" [(ngModel)]="minERContribution"> %
                          </div>
                        </div>
                      </div>
                      <label style="color:red;display:block;font-size:15px;text-align: center;">{{errorMsg}}</label>
                    </fieldset>
                  </div>
                </div>
                <div class="grid-x">
                  <div class="medium-12">
                    <fieldset class="grid-x">
                      <div class="medium-12">
                        <span class="fieldset-heading">ER Contribution to DP Premium </span>
                      </div>
                      <div class="grid-x medium-12">
                        <div class="medium-10">
                          <mat-slider #dpToEESlider step="1" class="tp-margin contribution-slider" [min]="0" [max]="100"
                            (change)="onChangeDPPercentageSlider($event)" [(ngModel)]="dpContribution">
                          </mat-slider>
                        </div>
                        <div class="medium-2">
                          <div class="text-center contribution-label" style="font-size: larger;padding: 0px;">
                            <input size="3" (keypress)="numberOnly($event)"
                              (blur)="setDPPercentageZeroContribution($event)"
                              class="mat-form-field-outline contribution-percentage" [(ngModel)]="dpContribution"> %
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div class="grid-x">
                  <div class="cell medium-6">
                    <h3 class="contribution-label-large">Based On</h3>
                  </div>
                </div>
                <div class="grid-x">
                  <div class="cell medium-12" *ngIf="isSamePackagePlanSelected">
                    <mat-radio-group [(ngModel)]="selectedPlantypeBasedOn">
                      <mat-radio-button
                        *ngFor="let employerContributionType of employerContributionTypes; let i = index"
                        [attr.data-qaauto]="employerContributionTypeId"
                        [value]="employerContributionType.employerContributionTypeId"
                        (click)="selectContributionType(employerContributionType.employerContributionTypeId,index)">
                        {{employerContributionType.employerContributionTypeName}} </mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <div class="cell medium-12" *ngIf="!isSamePackagePlanSelected">
                    <h3 class="contribution-label-large">Any Plan</h3>
                  </div>
                </div>
                <div class="selected-plan" *ngIf="showPlans && isSamePackagePlanSelected">
                  <div class="plan-details">
                    <div>
                      <mat-form-field appearance="fill" class="full-width">
                        <mat-select (selectionChange)="setContributionPlan($event)" [(ngModel)]="selectedPlanId">
                          <!-- <mat-option value=-1>Select Plan</mat-option> -->
                          <mat-option *ngFor="let plan of contributionPlans" [value]="plan.PlanId">
                            {{plan.PlanNetworkName}} </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div *ngIf="selectedTab == 'Dollar Amount'">
          <section class="container">
            <div class="grid-x">
              <div class="cell medium-12">
                <div>
                </div>
              </div>
            </div>
          </section>
          <section class="container">
            <div class="grid-x p-16">
              <div class="cell">
                <div class="grid-x">
                  <div class="cell medium-12">
                    <h3 class="contribution-heading"> Single Carrier Package</h3>
                  </div>
                  <div class="cell medium-12 contribution-label-large"> {{carrieName}} </div>
                </div>
                <div class="cell medium-8 contribution-label-large p-0 mt-10"> Pay Period Type: </div>
                <div class="cell medium-8 contribution-label-large p-0">
                  <mat-radio-group class="type-radio-buttons" [(ngModel)]="payPeriodSelected">
                    <mat-radio-button *ngFor="let payperiod of payPeriodList;let i=index"
                      [value]="payperiod.payPeriodId" class="contribution-label-large"
                      (change)="payPeriodTypeChange($event,index)"> {{payperiod.payPeriodName}}</mat-radio-button>
                  </mat-radio-group>
                </div>
                <div class="grid-x">
                  <div class="cell medium-8">
                    <h3>Flat Monthly Amount Paid By Employer</h3>
                  </div>
                </div>
                <div class="grid-x">
                  <div class="cell medium-12 p-0">
                    <h4>For Employee</h4>
                    <div> <span class="dollar-sign">$</span><input matInput type="number"
                        [(ngModel)]="rateTableInfo.EmployeeContribution.EmployeeContributionAmount"
                        pattern="^[0-9]+(\.[0-9][0-9]?)?$" autocomplete="off" value="0"
                        class="contribution-percentage contribution-flat" (blur)="setEmployeeDollarAmount($event)">
                    </div>
                  </div>
                </div>
                <div class="grid-x">
                  <div class="cell medium-12 p-0">
                    <h4>For Dependent</h4>
                    <div> <span class="dollar-sign">$</span><input matInput type="number"
                        [(ngModel)]="rateTableInfo.EmployeeContribution.DependentContributionAmount"
                        pattern="^[0-9]+(\.[0-9][0-9]?)?$" autocomplete="off" value="0"
                        class="contribution-percentage contribution-flat" (blur)="setDepDollarAmount($event)"></div>
                  </div>
                </div>
                <div class="grid-x">
                  <div class="cell medium-12">
                    <h3>Based On Any Plan</h3>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </mat-tab>
    </ng-container>
  </mat-tab-group>
</div>